/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type CoverageParametersCoverageAmountType =
  (typeof CoverageParametersCoverageAmountType)[keyof typeof CoverageParametersCoverageAmountType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CoverageParametersCoverageAmountType = {
  client_incomes: "client_incomes",
  family_expenses: "family_expenses",
  other: "other",
} as const;
